/**
 * 人才培养api
 */

import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /***** 培养方案  **********/

  // 门户-培养方案-年份列表
  getTrainingPlanYearList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-grade_list/training_plan_page`, params, config)
  },
  // 门户-培养方案-列表（内医大）
  getTrainingPlanPageList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-list2/training_plan_page`, params, config)
  },
  // 门户-培养方案-详情（内医大）
  getTrainingPlanDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-info/training_plan_page`, params, config)
  },

  /***** 课程大纲  **********/

  // 门户-课程大纲-年份列表
  getCourseOutlineYearList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-grade_list/course_outline_page`, params, config)
  },
  // 门户-课程大纲-专业列表（内医大）
  getCourseOutlineMajorList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-syllabi_major_list/course_outline_page`, params, config)
  },
  // 门户-课程大纲-课程列表（内医大）
  getOutlineCourseList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-syllabi_course_list/course_outline_page`, params, config)
  },
  // 门户-课程大纲-章节列表（内医大）
  getOutlineChapterList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-syllabi_outline_list/course_outline_page`, params, config)
  },
  // 门户-课程大纲-章节详情（内医大）
  getOutlineChapterDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-syllabi_outline_info/course_outline_page`, params, config)
  }
}
